
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"56","height":"56","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"id-43a","width":"150%","height":"150%","x":"-25%","y":"-17.9%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0 0 0 0 0 0.286648489 0 0 0 0 0.383463542 0 0 0 0.312445367 0"}})]),_c('path',{attrs:{"id":"id-44b","d":"M11.88 4.78A8.45 8.45 0 0123.16.84l-4.305 4.305-.133.141a2.83 2.83 0 00.133 3.863l-.117-.123c.03.132.097.258.2.361l5.8 5.799a8.472 8.472 0 01-8.851.938L4.835 27.17l-.141.133A2.832 2.832 0 01.83 23.166l11.049-11.05a8.446 8.446 0 010-7.336zm15.286.065a8.471 8.471 0 01-1.33 9.32L21.564 9.89a2.82 2.82 0 001.298-.74z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"28","cy":"28","r":"28","fill":"#97E1FA"}}),_c('g',{attrs:{"transform":"translate(14 14)"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#id-43a)","xlink:href":"#id-44b"}}),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#id-44b"}})])])])
          )
        }
      }
    